import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import { ChatMenu } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { anchorEl, selectedMenu, isVisibleChatCard } = state.chatMenu
  const { language } = state.user
  return ({
    anchorEl,
    selectedMenu,
    isVisibleChatCard,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { bid, liveId } = ownProps
  return ({
    handleClick: (event) => {
      dispatch(actions.chatMenu.open(event.currentTarget))
    },
    handleClose: () => {
      dispatch(actions.chatMenu.close())
    },
    handleExited: (selectedMenu) => () => {
      switch (selectedMenu) {
        case 'SHOW':
          dispatch(actions.chatMenu.showChatCard())
          break
        case 'HIDE':
          dispatch(actions.chatMenu.hideChatCard())
          break
        default:
          break
      }
    },
    handleSendBoard: () => {
      dispatch(api.live.sendBoardMessage(liveId, bid))
      dispatch(actions.chatMenu.close())
    },
    handleUserList: () => {
      dispatch(actions.usereListDialog.open())
      dispatch(actions.chatMenu.close())
    },
    handleShow: () => {
      dispatch(actions.chatMenu.selectedMenu('SHOW'))
      dispatch(actions.chatMenu.close())
    },
    handleHide: () => {
      dispatch(actions.chatMenu.selectedMenu('HIDE'))
      dispatch(actions.chatMenu.close())
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChatMenu)



// WEBPACK FOOTER //
// ./src/containers/Common/Chat/ChatMenu.js